import { Icon } from '../Icon'

import { Bar, BarContainer, BarLink } from './styles'

export function BarB2B() {
  return (
    <Bar aria-label="barra de navegação">
      <BarContainer>
        <div>
          <BarLink
            aria-label="Para pequenas e médias empresas"
            href="https://empresas.serasaexperian.com.br/"
          >
            Para PME
          </BarLink>
        </div>
        <div>
          <BarLink aria-label="Para empresas" href="https://www.serasaexperian.com.br/">
            Para empresas
          </BarLink>
        </div>
        <div>
          <BarLink aria-label="Global" href="https://www.serasaexperian.com.br/sites-globais/">
            <Icon icon="global" className="icon__global" />
            <span> Global</span>
          </BarLink>
        </div>
      </BarContainer>
    </Bar>
  )
}
